import axios from 'axios'
import { Message,MessageBox } from 'element-ui'
import store from '@/store/index/index'
import { getToken } from '@/utils/auth'
const urls = [ '/login', '/exist', '/article' , '/pdf','/dashboard']
// create an axios instance  MessageBox,
const request = axios.create({
    baseURL: '/api',
    timeout: 60000, // request timeout http://192.168.1.28:10086
    withCredentials: false
})

// request拦截器
request.interceptors.request.use(config => {
    // Do something before request is sent
    if (urls.indexOf(config.url) !== -1||(urls.indexOf('/articles/public/')>-1&&urls.indexOf('/articles/public/page')===-1)){
        // console.log(config.headers['Content-Type'])
        // config.withCredentials = true
        console.log('不需要token',config.url)
        return config
    }
    if (store.getters.token) {
        config.headers['token'] = 'Bearer ' + getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    /*if (config.headers['Content-Type'] === 'multipart/form-data') {
        return config
    }
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        return config
    }
    config.headers['Content-Type'] = "application/json;charset=UTF-8"*/
    //console.log(config)
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
request.interceptors.response.use(
    response => {
        /**
         *
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        const res = response.data;
        if (res.code !== 200&&res.code !== 8002) {
            /*Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000
            });*/
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if(res.code===401){
                console.log(location)
                MessageBox.confirm('token无效，请重新登录','提示', {
                    confirmButtonText: '重新登录',
                    type: 'warning'
                }).then(() => {
                    //console.log(store)
                    store.dispatch('user/logout').then(() => {
                        //console.log('重新刷新')
                        //location.reload();// 为了重新实例化vue-router对象 避免bug
                        //location.replace(location.origin)
                        location.assign(location.origin)
                    });
                })
                console.log('401',res)
                return
            }else if (res.code === 500 || res.code === 50012 || res.code === 50014) {
                /*MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('FedLogOut').then(() => {
                        location.reload();// 为了重新实例化vue-router对象 避免bug
                    });
                })*/
                // location.reload();// 为了重新实例化vue-router对象 避免bug
                console.log('500了',response)
            }
            console.log(res)
            return res
            // return Promise.reject('error');
        } else {
            // console.log(res)
            return res;
        }
    },
    error => {
        console.log('err' + error)// for debug
        Message({
            message: error.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    })
export default request
